import PageHero from "../components/PageHero.jsx";
import ProductCard from "../components/ProductCard.jsx";
import CTA from "../components/CTA.jsx";
import { ingredientCategories } from "../data/content.js";

const formatGroups = [
  "Slices",
  "Dices",
  "Flakes",
  "Tea cuts",
  "Granules",
  "Powders",
  "Custom blends"
];

export default function Products() {
  return (
    <>
      <PageHero
        eyebrow="Product ecosystem"
        title="Product Ecosystem"
        text="This page should not feel like a generic exporter product dump. Products are grouped into premium ingredient categories."
        image="/images/premium-powders.jpg"
      />

      <section className="content-band">
        <div className="section-inner">
          <div className="section-split">
            <div>
              <p className="eyebrow">Portfolio map</p>
              <h2>Products grouped into premium ingredient categories.</h2>
            </div>
            <p>
              This page is designed around the brief’s five categories: Freeze-Dried Fruits,
              Freeze-Dried Vegetables, Herbs & Botanicals, Tea Cuts & Wellness Ingredients, and
              Functional Powders & Blends.
            </p>
          </div>
          <div className="format-strip">
            {formatGroups.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="content-band product-band">
        <div className="section-inner product-list">
          {ingredientCategories.map((item) => (
            <ProductCard key={item.title} item={item} />
          ))}
        </div>
      </section>

      <section className="content-band dark-band">
        <div className="section-inner two-column">
          <div>
            <p className="eyebrow">Custom sourcing</p>
            <h2>Need something outside the listed families?</h2>
          </div>
          <p className="large-copy">
            Share the ingredient, target application, format, country, expected quantity and any
            certification requirement. We will assess feasibility and suggest the right sourcing route.
          </p>
        </div>
      </section>

      <CTA />
    </>
  );
}
